import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.admin, routes: [{ path: '/list-routes', component: FuseLoadable({ loader: () => import('./RoutesApp') }) }] };

export default [Index];
